import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import LoadingScreen from '../components/BasicComponent/LoadingScreen'
import { PATH } from '../constants/router'
import { useAppUserContext } from './AppUserContext'

const GUARDED_TRAFFIC_FINE_PATHS = [
  PATH.HOME,
  PATH.TRAFFIC_FINE_CONSENT,
  PATH.TRAFFIC_FINE_LOOKUP,
  PATH.TRAFFIC_FINE_CHECK_RESULT,
  PATH.TRAFFIC_FINE_SERVICES,
  PATH.TRAFFIC_FINE_VEHICLES,
  PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
  PATH.TRAFFIC_FINE_PACKAGE_INFO,
  PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
  PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME
]

function isGuardedTrafficFinePath(pathname = '') {
  if (GUARDED_TRAFFIC_FINE_PATHS.includes(pathname)) {
    return true
  }

  return pathname.startsWith(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS.replace(':id', ''))
}

export default function AppUserRouteGuard() {
  const history = useHistory()
  const location = useLocation()
  const { isLoadingUserData, isConsentRequired } = useAppUserContext()
  const isGuardedPath = isGuardedTrafficFinePath(location.pathname)
  const isAuthenticationPath = [PATH.HOME, PATH.TRAFFIC_FINE_CONSENT].includes(location.pathname)

  React.useEffect(() => {
    if (!isGuardedPath || isLoadingUserData || !isConsentRequired || isAuthenticationPath) {
      return
    }

    history.replace({ pathname: PATH.TRAFFIC_FINE_CONSENT, search: location.search })
  }, [history, isAuthenticationPath, isConsentRequired, isGuardedPath, isLoadingUserData, location.search])

  if (!isGuardedPath || !isLoadingUserData) {
    return null
  }

  return <LoadingScreen open />
}
